export const AccountingRoute = {
  ACCOUNTING: 'accounting',
  OVERVIEW: {
    name: 'accounting-overview',
    path: 'overview'
  },
  ASSETS: {
    name: 'accounting-assets',
    path: 'assets'
  },
  LIABILITIES: {
    name: 'accounting-liabilities',
    path: 'liabilities'
  },
  CASHFLOWS: {
    name: 'accounting-cashflows',
    path: 'cashflows'
  },
  CONNECTIONS: {
    name: 'accounting-connections',
    path: 'connections'
  },
  TAXES: {
    name: 'accounting-taxes',
    path: 'taxes'
  },
  ESTATE_DISTRIBUTION: {
    name: 'accounting-estate-distribution',
    path: 'distribution'
  },
  ACCOUNTING_TAB: {
    name: 'accounting-tab',
    path: 'accounting-tab'
  }
};
